<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="isOwner == true"
          data-testid="edit-space-owner-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-space-owner-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateSpaceOwner"
          @submit.prevent
        >
          <v-toolbar dark color="accent">
            <v-btn data-testid="close-button" icon dark @click="reloadForm">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t("editSpaceOnwerTitle") }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateSpaceOwner"
            >
              {{ $t("save") }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error"
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <div class="pt-15 px-md-12">
                  <p class="text-h5 font-weight-bold darktext--text">
                    {{ $t("editSpaceOwnerTitle") }}
                  </p>
                  <p class="text-body-1 greytext--text mb-0">
                    {{ $t("editSpaceOwnerText") }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-col cols="11" class="mx-auto px-0">
            <v-radio-group v-model="setSpaceOwner">
              
              <v-card
                v-for="user in users"
                :key="user.id"
                rounded="xxl"
                class="my-2 solo"
                
              >
               <v-hover>
               <v-radio  slot-scope="{ hover }"
               :class="`py-3 elevation-${hover ? 8 : 2}`"

                        :key="user.id"
                        :value="user.id"
                        color="accent"
                        class="option rounded-xxl radio-card"
                        data-testid="choose-space-owner"
                        active-class="selected"
                        style="height:76px"
                      >
                      
                <template v-slot:label > 
               
                  <v-row
                    v-if="mobile()"
                    no-gutters
                    
                  >
                  <v-col 
                    cols="10"
                    class="d-flex justify-left align-center "
                  >
                    <v-avatar
                      size="38"
                      class="ml-4 mr-2"
                    >
                      <img
                        v-if="user.attributes.avatar_thumb == null"
                        :src="defaultImage"
                      />
                      <img v-else :src="`${user.attributes.avatar_thumb}`" />
                    </v-avatar>
                    <div class="mail-name text-no-wrap text-truncate mr-4">
                      <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                        {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                      </v-card-text>
                      <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                        {{ user.attributes.email }} 
                      </v-card-text>
                    </div>
                  </v-col>
      
                  </v-row>
                 
                  <v-row
                    v-if="!mobile()"
                    no-gutters
                  >
                  <v-col
                    md="1"
                    align="center"
                  >
                    <v-avatar
                      size="38"
                      class="mx-2"
                    >
                      <img
                        v-if="user.attributes.avatar_thumb == null"
                        :src="defaultImage"
                      >
                      <img
                        v-else
                        :src="`${user.attributes.avatar_thumb}`"
                      >
                    </v-avatar>
                  </v-col>

                  <v-col
                    md="4"
                    align="left"
                  >
                    <div class="text-body-2 grey--text justify-left">
                      {{ $t('name') }}
                    </div>
                    <div class="text-body-1 darktext--text">
                      {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                    </div>
                  </v-col>

                  <v-col
                    md="5"
                    align="left"
                    class="pl-2"
                  >
                    <div class="text-body-2 grey--text justify-left">
                      {{ $t('mail') }}
                    </div>
                    <div class="text-body-1 darktext--text">
                      {{ user.attributes.email }}
                    </div>
                  </v-col>

                    <v-col 
                      md="2" 
                      align="left"
                      class="pl-2"
                  >
                      <div class="text-body-2 grey--text justify-left">
                        {{ $t("role") }}
                      </div>
                      <div
                        v-if="permissions[user.id] == 'Space Admin'"
                        class="text-body-1 darktext--text"
                      >
                        {{ $t("spaceAdmin") }}
                      </div>
                    </v-col>
                  </v-row>                
                 </template>
                </v-radio>
                 </v-hover>
              </v-card>
            </v-radio-group>
          </v-col>

        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import { getSpaceAdmins, changeSpaceOwner, getSpace } from "../../api/spaceApi";
import AlertMessages from "../../components/AlertMessages";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";

export default {
  components: {
    AlertMessages,
  },
  props: {
    selectedOwner: {
      type: String,
      default: "",
    },
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      dialog: false,
      valid: true,
      alertMsg: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      loading: false,
      val: "",
      usersInfo: {
        currentPage: 1,
        total: 0,
      },
      users: [],
      permissions: [],
      defaultImage: require("../../assets/user_images/profile-avatar.png"),
      isOwner: localStorage.space
        ? JSON.parse(localStorage.space).is_owner
        : false,
    };
  },
  computed: {
    setSpaceOwner: {
      get() {
        return this.val;
      },
      set(selectedOwner) {
        this.val = selectedOwner;
      },
    },
  },
  watch: {
    selectedOwner(newVal) {
      this.val = newVal;
    },
  },
  async mounted() {
     await this.fetchSpaceAdmins();
      if (this.users.find((user) => user.id == this.usersInfo.owner)) {
        this.setSpaceOwner = this.users.find(
          (user) => user.id == this.usersInfo.owner
        ).id;
      }
  },
  async created() {
    this.loadingData = true;
    await this.fetchSpaceAdmins();
    if (this.users.find((user) => user.id == this.usersInfo.owner)) {
      this.setSpaceOwner = this.users.find(
        (user) => user.id == this.usersInfo.owner
      ).id;
    }
    this.loadingData = false;
  },
  methods: {
    async updateSpaceOwner() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        var alertType = "";
        var alertMsg = "";
        try {
          let data = {
            data: {
              type: "spaces",
              id: this.spaceId,
              attributes: {
                user_id: this.setSpaceOwner,
              },
            },
          };
          const response = await changeSpaceOwner(this.spaceId, data);
          if (response.status == 200) {
            const responseSpace = await getSpace(this.spaceId);
            if (responseSpace.status == 200) {
              alertType = "success";
              alertMsg = i18n.t("changeSpaceOwnerSuccess");
              this.isOwner = responseSpace.data.data.attributes.is_owner;
              localStorage.space = JSON.stringify(
                responseSpace.data.data.attributes
              );
              this.$emit("proceedSubmit", alertMsg, alertType);
              this.reloadForm();
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response) {
              this.alertValue = true;
              if (e.response.status == 400) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  if (
                    e.response.data.errors[i].detail ==
                    "You can not make this user owner of the space."
                  ) {
                    this.alertType = "error";
                    this.alertMsg = i18n.t("updateSpaceOwnerError");
                  } else {
                    alertType = "error";
                    alertMsg = i18n.t("serverError");
                    this.$emit("proceedSubmit", alertMsg, alertType);
                    this.reloadForm();
                  }
                }
              } else {
                alertType = "error";
                alertMsg = i18n.t("serverError");
                this.$emit("proceedSubmit", alertMsg, alertType);
                this.reloadForm();
              }
            }
          }
        }
        this.loading = false;
      }
    },
    async fetchSpaceAdmins() {
      try {
        const response = await getSpaceAdmins(this.spaceId);
        if (response.status) {
          if (response.status == 200) {
            this.users = response.data.data;
            window.scrollTo(0, 0);
            this.usersInfo = response.data.meta;
            this.permissions = response.data.meta.permissions;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    reloadForm() {
      (this.dialog = false),
        (this.alertMsg = ""),
        (this.setSpaceOwner = this.users.find(
          (user) => user.id == this.usersInfo.owner
        ).id);
    },
  },
};
</script>
<style>
.radio-card .v-input--selection-controls__input{
  margin-left: 32px;
}
</style>